
export default function SnapSystem() {
  return (
    <section id="snap-system" className="py-24 relative overflow-hidden bg-gradient-to-b from-white via-[#C8D8E4]/8 to-white">
      {/* Soft Decorative Background */}
      <div className="absolute top-1/3 left-0 w-[600px] h-[600px] bg-[#52AB98]/8 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 right-0 w-[500px] h-[500px] bg-[#F6D7DF]/12 rounded-full blur-3xl"></div>
      
      <div className="max-w-[1200px] mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Visual */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              {/* Main Image Container */}
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://static.readdy.ai/image/a109cef237b31571116f6f567dd6e069/c02985f4098e7af577b15c17a7a6e1be.png"
                  alt="Photo-based window measurement system"
                  className="w-full h-auto object-cover"
                  style={{ aspectRatio: '6/7' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2B6777]/20 to-transparent"></div>
              </div>

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 border border-[#F2F2F2]">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#52AB98]/10 rounded-xl">
                    <i className="ri-camera-line text-2xl text-[#52AB98]"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-[#2B6777]">Photo Upload</p>
                    <p className="text-xs text-[#2B6777]/60">Secure & Simple</p>
                  </div>
                </div>
              </div>

              {/* Decorative Element */}
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#F6D7DF]/20 rounded-full blur-2xl"></div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="order-1 lg:order-2">
            {/* Headline */}
            <h2 className="text-4xl md:text-5xl lg:text-[3.25rem] font-heading font-bold tracking-tight leading-[1.1] mb-5">
              <span className="bg-gradient-to-r from-[#2B6777] via-[#3a8a7a] to-[#52AB98] bg-clip-text text-transparent">
                The AI Window
              </span>
              <br />
              <span className="relative inline-block">
                <span className="bg-gradient-to-r from-[#52AB98] to-[#2B6777] bg-clip-text text-transparent">
                  Snapshot System
                </span>
                <span className="absolute -bottom-1 left-0 w-full h-[3px] bg-gradient-to-r from-[#52AB98] to-[#2B6777] rounded-full"></span>
              </span>
            </h2>

            {/* Punchy Subtitle */}
            <p className="text-xl md:text-2xl font-medium text-[#2B6777] leading-snug mb-8">
              Turn a simple photo of your home into accurate window replacement quotes serving in{' '}
              <span className="relative inline-block px-2 py-0.5 mx-0.5">
                <span className="absolute inset-0 bg-[#52AB98]/15 rounded-md"></span>
                <span className="relative font-bold text-[#52AB98]">42 different states</span>
              </span>{' '}
              — without sales visits, pressure, or guesswork.
            </p>

            {/* Body */}
            <p className="text-lg text-[#2B6777]/70 leading-relaxed mb-6">
              SNAPWindows.ai uses a secure, photo-based system to understand your windows from the exterior of your home. This allows us to identify window locations, types, and sizing so we can provide accurate pricing, without in-home sales visits or disruption to your space.
            </p>

            <p className="text-lg text-[#2B6777]/70 leading-relaxed mb-6">
              Your photos are used only to evaluate your windows. We don't access personal information, and your data is handled securely at every step.
            </p>

            <p className="text-lg text-[#2B6777]/70 leading-relaxed mb-8">
              Before anything is ordered, a licensed professional verifies all measurements before your custom windows are ordered.
            </p>

            {/* Mini Callout */}
            <div className="bg-gradient-to-br from-[#2B6777]/5 to-[#52AB98]/5 rounded-2xl p-6 border border-[#52AB98]/20">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#52AB98] rounded-xl flex-shrink-0">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-base font-medium text-[#2B6777] leading-relaxed">
                    You're not placing trust in a single tool—you're trusting a thoughtfully designed process, supported by real professionals, built to protect your home and your peace of mind.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
